import { render, staticRenderFns } from "./Poc.vue?vue&type=template&id=46b02206&scoped=true"
import script from "./Poc.vue?vue&type=script&lang=js"
export * from "./Poc.vue?vue&type=script&lang=js"
import style0 from "./Poc.vue?vue&type=style&index=0&id=46b02206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b02206",
  null
  
)

export default component.exports